import * as shell from "./shell.js";
import * as openings from "./openings.js";
import * as interior from "./interior.js";
import * as stairs from "./stairs.js";
import * as upstairs from "./upstairs.js";
import * as porch from "./porch.js";
import * as sidepath from "./sidepath.js";
import * as frontyard from "./frontyard.js";
import * as deck from "./deck.js";
import * as patio from "./patio.js";
import * as shed from "./shed.js";
import * as garden from "./garden.js";
import { gradeFor } from "../spec.js";

/**
 * The middle house, rebuilt in detail from a photograph.
 *
 * Modules written independently against hero/spec.js: the masonry and roofs,
 * the windows and doors that fill the openings the shell leaves, the two
 * storeys inside and the stair between them, the porch, and the planting out
 * front.
 */
// The back garden is a terrace 0.80 m below the house, which is what makes
// the deck a raised one -- spec.MODULE_GRADE says which parts sit down there.
// Those four modules were written against backspec's own datum (grade 0 at
// the lawn) and still are; they are simply built one terrace down, as a unit.
const PARTS = [
  ["shell", shell],
  ["openings", openings],
  ["interior", interior],   // the rooms the shell encloses
  ["stairs", stairs],       // the dog-leg up, and the closet beside it
  ["upstairs", upstairs],   // the storey the shell always had room for
  ["porch", porch],
  ["sidepath", sidepath],
  ["frontyard", frontyard],
  ["garden", garden],       // lawn and beds first: everything else sits on them
  ["deck", deck],
  ["patio", patio],
  ["shed", shed],
];

export function build(b) {
  for (const [name, mod] of PARTS) {
    const fn = mod.build ?? mod.default;
    if (typeof fn !== "function") {
      console.warn(`hero: ${name} has no build()`);
      continue;
    }
    try {
      b.setOwner(`hero/${name}`);
      b.setGrade(gradeFor(`hero/${name}`));
      fn(b);
    } catch (e) {
      console.error(`hero: ${name} failed --`, e);
    }
  }
}
